<template>
    <div :class="['article-card', col, {'article-card--large': large}]">
        <div class="article-card__inner">
            <a class="article-card__cover" :href="url">
                <img :src="image.src" :alt="image.alt" :title="image.title">
            </a>
            <div class="article-card__body">
                <div class="article-card__meta flex v-center" v-if="tags">
                    <a-badge v-for="tag in tags">{{ tag }}</a-badge>
                </div>
                <a :href="url" class="article-card__title">{{ title }}</a>
                <div class="article-card__text" v-if="text" v-html="text"></div>
            </div>
        </div>
    </div>
</template>

<script>

import {ABadge} from '../ui'

export default {
    name: 'ArticleCard',
    inheritAttrs: false,
    components: {
        ABadge,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
        url: {
            type: String,
            default: '',
        },
        image: {
            type: String,
            default: '',
        },
        tags: Array,
        // date: {
        //     type: String,
        //     default: '',
        // },
        // readTime: {
        //     type: String,
        //     default: '',
        // },
        col: {
            type: String,
            default: '',
        },
        large: {
            type: Boolean,
            default: false
        }
    },
    setup: (props, ctx) => {

        return {}
    },
}
</script>

<style lang="scss">
.article-card {

    &--large {
        .article-card__inner {
            display: flex;
            gap: 20px;

            @include mobile {
                flex-direction: column;
            }
        }

        .article-card__cover {
            width: 70%;

            @include mobile {
                width: 100%;
            }
        }

        .article-card__body {
            padding-left: 100px;

            @include tablet {
                padding-left: unset;
            }
        }
    }

    &__cover {
        display: block;
        line-height: 1px;
        border-radius: var(--br-1);
        overflow: hidden;
        max-height: 370px;

        img {
            object-fit: cover;
            width: 100%;
        }
    }

    &__body {
        margin-top: 26px;

        @include tablet {
            margin-top: 16px;
        }
    }

    &__meta {
        margin-bottom: 10px;
    }

    &__title {
        font-family: var(--font-secondary);
        font-weight: 600;
        font-size: 22px;
        line-height: 28px;
        color: var(--c-gray-100);
        float: left;

        .article-card--large & {
            font-size: 40px;
            line-height: 44px;
            padding: 40px 0;

            @include tablet {
                font-size: 22px;
                line-height: 28px;
                padding: 20px 0;
            }
        }

        @include tablet {
            font-size: 16px;
            line-height: 24px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }

    &__text {
        margin-top: 30px;
        font-size: 16px;
        line-height: 26px;
        float: left;

        @include tablet {
            font-size: 14px;
            line-height: 20px;
            margin-top: 18px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
    }

    .a-badge {
        margin-left: 10px;

        &-inner {
            @include tablet {
                font-size: 12px;
            }
        }

        &:first-child {
            margin-left: 0;
        }
    }
}
</style>
